export default __webpack_public_path__ + "images/models/f72fa9fc5d089c6e4f3263b840c69099.usdz";